import { createContext, useContext } from 'react';

import { PieChartToolbarConfig } from '../types/toolbar.js';

export const ToolbarContext = createContext<PieChartToolbarConfig | undefined>(
  undefined,
);

export const useToolbarConfig = () => useContext(ToolbarContext);

ToolbarContext['displayName'] = 'ToolbarContext';
